module.exports = __webpack_public_path__ + "static/img/EH@3x.58cd737a.jpg";